import PropTypes from 'prop-types';
import { graphql, useFragment } from 'react-relay';

// components
import { SbSharedRefineMenuRadioSelectList } from '../SbSharedRefineMenuRadioSelect/SbSharedRefineMenuRadioSelectList.jsx';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuFilterItemType_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuRadioSelectList_itemSearch
    }
`;

export const SbSharedRefineMenuFilterItemType = ({
    itemSearch: itemSearchRef,
    values,
    filterName,
    allLabel,
    totalCount,
    notDismissable,
    collapsedItemCount,
    shouldUseExpandableList,
    showAllOption,
    trackingOptions,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    return (
        <SbSharedRefineMenuRadioSelectList
            itemSearch={itemSearch}
            values={values}
            filterName={filterName}
            allLabel={allLabel}
            totalCount={totalCount}
            notDismissable={notDismissable}
            collapsedItemCount={collapsedItemCount}
            shouldUseExpandableList={shouldUseExpandableList}
            showAllOption={showAllOption}
            trackingOptions={trackingOptions}
        />
    );
};

SbSharedRefineMenuFilterItemType.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    values: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
    allLabel: PropTypes.string,
    totalCount: PropTypes.number,
    notDismissable: PropTypes.bool,
    collapsedItemCount: PropTypes.number,
    shouldUseExpandableList: PropTypes.bool,
    showAllOption: PropTypes.bool,
    trackingOptions: PropTypes.object,
};
